import ButtonIcon from "components/ButtonIcon";
import Table from "components/Template/Table";
import React from "react";
import Edit from "icons/edit.svg";
import Close from "icons/trash-green.svg";
import { useHistory } from "react-router-dom";

type Props = {
  dataList: Array<any>;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteId: React.Dispatch<React.SetStateAction<string>>;
};

const TableAdmin: React.FC<Props> = ({
  dataList,
  setShow,
  setDeleteId,
}): JSX.Element => {
  let history = useHistory();

  const showRemove = (id: string) => {
    setShow(true);
    setDeleteId(id);
  };

  return (
    <Table
      childrenThead={
        <tr className="font-sora">
          <td className="px-7">Name</td>
          <td>Email</td>
          <td>Edit</td>
          <td>Remove</td>
        </tr>
      }
      childrenTbody={
        <>
          {dataList.map((data: any, i: number) => (
            <tr className="font-sora" key={i}>
              <td className="px-7 py-7">{data.name}</td>
              <td>{data.email}</td>
              <td style={{ width: "70px" }}>
                <ButtonIcon
                  icon={Edit}
                  onClick={() => {
                    history.push(`/bridge-talk-admin/${data._id}/edit`);
                  }}
                  status={true}
                />
              </td>
              <td style={{ width: "70px" }}>
                <ButtonIcon
                  icon={Close}
                  onClick={() => showRemove(data._id)}
                  status={true}
                />
              </td>
            </tr>
          ))}
        </>
      }
    />
  );
};

export default TableAdmin;
